
export const fetchFile = async (url) => {
    return await fetch(url);
};

export const getFileType = async (file) => {
    const contentType = file.headers.get("content-type");
    return contentType.split("/")[1]; // extract the file type from the content-type header
};